import styled from 'styled-components';

export const ProductTagsContainer = styled.div`
  flex-direction: row;
  display: flex;

  > span {
    font-weight: 500;
    font-size: ${({ theme }) => theme.unit * 1.5}px;
  }
`;

export const LinkButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.brand.primary};
`;
